import { CurrencyIcon } from '~/components/collections';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { rage, useObservable } from '~/rage';
import { Currency } from '~/shared';
import {
	StyledAmount,
	StyledAmounts,
	StyledArt,
	StyledBar,
	StyledContainer,
	StyledDiamond,
	StyledDivider,
	StyledLights,
	StyledRings,
	StyledShadow,
} from './Reward.styled';

const Reward = () => {
	const reward = useObservable(rage.betaRewards.getReward());
	const rubleIcon = useWalletIcon(Currency.Ruble, true);
	const donateIcon = useWalletIcon(Currency.Donate, true);

	return (
		<StyledContainer>
			<StyledLights />
			<StyledRings />
			<StyledArt />
			<StyledDiamond $left={20} />
			<StyledDiamond $left={370} />
			<StyledShadow />
			<StyledBar>
				<Text>Ваша награда</Text>
				<StyledAmounts>
					<StyledAmount>
						<Text>{reward.money.toLocaleString('ru-RU')}</Text>
						<CurrencyIcon icon={rubleIcon} size={'md'} />
					</StyledAmount>
					<StyledDivider />
					<StyledAmount>
						<Text>{reward.donate.toLocaleString('ru-RU')}</Text>
						<CurrencyIcon icon={donateIcon} size={'md'} />
					</StyledAmount>
				</StyledAmounts>
			</StyledBar>
		</StyledContainer>
	);
};

export { Reward };
